import { useCallback, useEffect, useState } from 'react';
import {
  answerArtistOnboardingStep,
  dismissArtistOnboarding as dismissArtistOnboardingRequest,
  getArtistOnboardingStatus,
  refreshArtistOnboardingStatus,
} from '../api/artistSetup';

const createInitialState = () => ({
  loading: true,
  error: '',
  required: false,
  flow: null,
  currentStep: null,
  steps: [],
  profile: null,
  bankInfo: null,
  photoCount: 0,
});

const useArtistOnboardingStatus = () => {
  const [state, setState] = useState(createInitialState);

  const applyPayload = useCallback((payload = {}) => {
    setState({
      loading: false,
      error: '',
      required: Boolean(payload.required),
      flow: payload.flow || null,
      currentStep: payload.currentStep || null,
      steps: Array.isArray(payload.steps) ? payload.steps : [],
      profile: payload.profile || null,
      bankInfo: payload.bankInfo || null,
      photoCount: Number(payload.photoCount || 0),
    });
  }, []);

  const refresh = useCallback(async ({ silent = false } = {}) => {
    if (!silent) {
      setState((prev) => ({ ...prev, loading: true, error: '' }));
    }
    try {
      const data = await getArtistOnboardingStatus();
      applyPayload(data);
      return data;
    } catch (error) {
      setState((prev) => ({
        ...prev,
        loading: false,
        error: error?.message || 'オンボーディング状況の取得に失敗しました',
      }));
      throw error;
    }
  }, [applyPayload]);

  const answerStep = useCallback(async (stepKey, answer) => {
    const data = await answerArtistOnboardingStep(stepKey, answer);
    applyPayload(data);
    return data;
  }, [applyPayload]);

  const refreshAfterMutation = useCallback(async () => {
    const data = await refreshArtistOnboardingStatus();
    applyPayload(data);
    return data;
  }, [applyPayload]);

  const dismissOnboarding = useCallback(async () => {
    const data = await dismissArtistOnboardingRequest();
    applyPayload(data);
    return data;
  }, [applyPayload]);

  useEffect(() => {
    refresh().catch(() => {});
  }, [refresh]);

  return {
    ...state,
    answerStep,
    dismissOnboarding,
    refresh,
    refreshAfterMutation,
  };
};

export default useArtistOnboardingStatus;
